<div class="-mt-6 mb-5">
<div class="mb-3 w-full text-center text-lg">{{'DEPOSIT.NO_DEPOSIT' | translate}}</div>
<p-button [label]="'common.BUTTONS.BTN_ADD_DEPOSIT' | translate" icon="fa fa-plus" (click)="addDepositModal()" styleClass="p-button-outlined text-sm surface-0"></p-button>
</div>